module.exports = __webpack_public_path__ + "img/box.d31318e5.png";